export const headingStyle = {
  background: 'rgb(33,150,243)',
  backgroundImage:
    'linear-gradient(90deg, rgba(33,150,243,1) 0%, rgba(0,92,219,1) 50%, rgba(33,150,243,1) 100%)',
  position: 'relative',
  boxShadow: '0px 41px 16px -27px rgba(0,0,0,0.17)',
  borderRadius: '25px',
  margin: '20px',
  overflow: 'hidden',
}
